import * as ToastPrimitive from '@radix-ui/react-toast';
import { useToastStore } from '@/lib/toast';

// Lightweight Radix-backed toast container. Toasts emit via `toast()` helper
// (in src/lib/toast.ts); this component just renders the queue.

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    <ToastPrimitive.Provider swipeDirection="right" duration={5000}>
      {toasts.map((t) => (
        <ToastPrimitive.Root
          key={t.id}
          open
          onOpenChange={(open) => !open && dismiss(t.id)}
          data-testid="toast"
          data-variant={t.variant ?? 'info'}
          className="surface-elevated data-[state=open]:animate-in data-[state=closed]:animate-out p-4"
        >
          {t.title && (
            <ToastPrimitive.Title className="font-medium text-[var(--color-ink)]">
              {t.title}
            </ToastPrimitive.Title>
          )}
          {t.description && (
            <ToastPrimitive.Description className="mt-1 text-[var(--color-ink-muted)] text-[var(--text-sm)]">
              {t.description}
            </ToastPrimitive.Description>
          )}
        </ToastPrimitive.Root>
      ))}
      <ToastPrimitive.Viewport className="fixed right-4 bottom-4 z-[var(--z-toast)] flex w-96 max-w-full flex-col gap-2" />
    </ToastPrimitive.Provider>
  );
}
